import { render, staticRenderFns } from "./ListagemEtiquetas.vue?vue&type=template&id=6c2271fa"
import script from "./ListagemEtiquetas.vue?vue&type=script&lang=js"
export * from "./ListagemEtiquetas.vue?vue&type=script&lang=js"
import style0 from "./ListagemEtiquetas.vue?vue&type=style&index=0&id=6c2271fa&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c2271fa')) {
      api.createRecord('6c2271fa', component.options)
    } else {
      api.reload('6c2271fa', component.options)
    }
    module.hot.accept("./ListagemEtiquetas.vue?vue&type=template&id=6c2271fa", function () {
      api.rerender('6c2271fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/traceabilitytags/components/ListagemEtiquetas.vue"
export default component.exports